<template>
  <div class="component-library">
    <div class="library-header">
      <h3>Component Library</h3>
      <input v-model="searchQuery" placeholder="Search components..." />
    </div>
    <div class="component-grid">
      <div
        v-for="component in filteredComponents"
        :key="component.name"
        class="component-card"
        draggable="true"
        @dragstart="(event) => dragStart(event, component)"
        @click="addComponent(component)"
      >
        <div class="component-icon">
          <component :is="component.icon" />
        </div>
        <div class="component-info">
          <h4>{{ component.name }}</h4>
          <p>{{ component.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

interface Component {
  name: string
  description: string
  code: string
  icon: any
  category: string
}

const props = defineProps({
  components: {
    type: Array as () => Component[],
    default: () => []
  }
})

const emit = defineEmits(['add-component'])

const searchQuery = ref('')

const filteredComponents = computed(() => {
  return props.components.filter(comp => 
    comp.name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    comp.description.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const addComponent = (component: Component) => {
  emit('add-component', component.code)
}

const dragStart = (event: DragEvent, component: Component) => {
  if (event.dataTransfer) {
    event.dataTransfer.setData('text/plain', component.code)
  }
}
</script>

<style scoped>
/* Your existing styles */
</style>
